import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  COURSE_PAUSE_REQUEST_TYPE_OPTIONS,
  COURSE_PAUSE_TYPE_PLACEHOLDER_MAP,
} from 'features/courseResume';
import Select from 'components/Select';
import styles from './CoursePauseTypeSelect.module.scss';

function CoursePauseTypeSelect() {
  const navigate = useNavigate();
  const { requestType } = useParams();
  const coursePauseType = {
    label: COURSE_PAUSE_TYPE_PLACEHOLDER_MAP[requestType],
    value: `/course-pause/${requestType}/to-be-resumed`,
  };

  const _styles = {
    control: (styles, state) => ({
      ...styles,
      height: '4.5rem',
    }),
  };

  const handleOnChange = useCallback(
    (option) => {
      navigate(option.value);
    },
    [navigate]
  );

  return (
    <Select
      styles={_styles}
      options={COURSE_PAUSE_REQUEST_TYPE_OPTIONS}
      value={coursePauseType}
      className={styles.select}
      onChange={handleOnChange}
    />
  );
}

export default CoursePauseTypeSelect;
